import React from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

export const SunnGlassesSlider = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 4
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  return (
    <div className="mx-auto px-5 lg:px-24 xl:mb-28 mb-8">
      <div className="flex place-content-between border-b-[1px] border-gray-300">
        <div className="lg:text-2xl text-xl font-light">SUNGLASSES</div>
        <div className=""><Link to="#" className="text-cyan-500">View Range</Link></div>
      </div>
      <div className="eyeglass">
        <Carousel responsive={responsive} infinite={true}>
          <Link to="#"><img src="images/sunglass-01.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/sunnglass-02.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/sunnglass-03.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/sunnglass-04.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/sunnglass-05.jpeg" alt="Image1" /></Link>
          <Link to="#"><img src="images/sunnglass-06.jpeg" alt="Image1" /></Link>
        </Carousel>
      </div>
    </div>
  )
}